import moment from 'moment';

export function formatDateTime(dateTime: Date, formatString: string): string;
export function formatDateTime(dateTime: string, formatString: string): string;
export function formatDateTime(dateTime: any, formatString: string): string {
	if (!dateTime) {
		return '';
	}

	const d = dateTime instanceof Date ? dateTime : dateFromStringValhalla(dateTime);
	return formatString
		.replace(new RegExp('HH', 'g'), ('00' + d.getHours()).slice(-2))
		.replace(new RegExp('mm', 'g'), ('00' + d.getMinutes()).slice(-2))
		.replace(new RegExp('ss', 'g'), ('00' + d.getSeconds()).slice(-2))
		.replace(new RegExp('dd', 'g'), ('00' + d.getDate()).slice(-2))
		.replace(new RegExp('MM', 'g'), ('00' + (d.getMonth() + 1)).slice(-2))
		.replace(new RegExp('yyyy', 'g'), ('000' + d.getFullYear()).slice(-4))
		.replace(new RegExp('yy', 'g'), ('0' + d.getFullYear()).slice(-2));
}

export function getDateFromString(strDateTime) {
	const d = new Date(1900, 0, 1);

	const expr = /(\d{1,2})?\.?(\d{2})?\.?(\d{4})?\s?(\d{1,2})?:?(\d{2})?:?(\d{2})?/;

	const matches = expr.exec(strDateTime);

	if (!matches || !matches[0]) {
		return null;
	}

	d.setFullYear(parseInt(matches[3], 10) || 1900);
	d.setMonth(matches[2] ? parseInt(matches[2], 10) - 1 : 0);
	d.setDate(parseInt(matches[1], 10) || 0);
	d.setHours(parseInt(matches[4], 10) || 0);
	d.setMinutes(parseInt(matches[5], 10) || 0);
	d.setSeconds(parseInt(matches[6], 10) || 0);

	return d;
}

export function dateFromStringValhalla(dateStr: string) {
	dateStr = dateStr || '';
	if (!dateStr.trim()) {
		return;
	}
	let date: Date;
	if (typeof dateStr === 'string' && dateStr.indexOf('/Date(') !== -1) {
		const timeUtc = Number(dateStr.replace('/Date(', '').replace(')/', ''));
		date = new Date(timeUtc);
	} else {
		date = new Date(dateStr);
	}
	return date;
}

export function isValidDate(date: Date) {
	return date instanceof Date && !isNaN(date.getTime());
}

export function getFirstDayOfMonth(date: Date) {
	let dateCopy;
	if (moment.isMoment(date)) {
		dateCopy = new Date(date.valueOf());
	} else {
		dateCopy = new Date(date.getTime());
	}

	dateCopy.setDate(1);
	dateCopy.setHours(0, 0, 0, 0);
	return dateCopy;
}

const optionsEqualsDateDefault = () => ({
	matchYear: true,
	matchMonth: true,
	matchDate: true,
	matchHour: true,
	matchMinutes: true,
	matchSeconds: true,
	matchMilliseconds: true,
});

export function isDateEquals(d1: Date, d2: Date, options?: Partial<typeof optionsEqualsDateDefault>) {
	if (!options) {
		return d1.getTime() === d2.getTime();
	}
	if (!d1 || !d2) {
		return false;
	}
	const matchOptions = Object.assign(optionsEqualsDateDefault(), options);
	let result = true;
	if (matchOptions.matchYear) {
		result = result && d1.getFullYear() === d2.getFullYear();
	}
	if (matchOptions.matchMonth) {
		result = result && d1.getMonth() === d2.getMonth();
	}
	if (matchOptions.matchDate) {
		result = result && d1.getDate() === d2.getDate();
	}
	if (matchOptions.matchHour) {
		result = result && d1.getHours() === d2.getHours();
	}
	if (matchOptions.matchMinutes) {
		result = result && d1.getMinutes() === d2.getMinutes();
	}
	if (matchOptions.matchSeconds) {
		result = result && d1.getSeconds() === d2.getSeconds();
	}
	if (matchOptions.matchMilliseconds) {
		result = result && d1.getMilliseconds() === d2.getMilliseconds();
	}
	return result;
}

export function isToday(date: Date) {
	if (!(date instanceof Date)) {
		return false;
	}
	const now = new Date();
	return (
		date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()
	);
}

export function isTodayNew(date: Date) {
	const today = moment();
	const currenrDay = moment(date);

	return (
		today.date() === currenrDay.date() && today.month() === currenrDay.month() && today.year() === currenrDay.year()
	);
}

export function isTommorowNew(date: Date) {
	const tommorow = moment().add(1, 'days');
	const currenrDay = moment(date);

	return (
		tommorow.date() === currenrDay.date() &&
		tommorow.month() === currenrDay.month() &&
		tommorow.year() === currenrDay.year()
	);
}

export function isYesterday(date: Date) {
	const yesterday = moment().add(-1, 'days');
	const currenrDay = moment(date);

	return (
		yesterday.date() === currenrDay.date() &&
		yesterday.month() === currenrDay.month() &&
		yesterday.year() === currenrDay.year()
	);
}

export function isTomorrow(date: Date) {
	const tomorrow = new Date(Date.now() + 24 * 3600 * 1000);
	return isDateEquals(date, tomorrow, {
		matchMilliseconds: false,
		matchSeconds: false,
		matchMinutes: false,
		matchHour: false,
	});
}

export function isPast(date: Date) {
	return Date.now() > date.getTime();
}

export function isFuture(date: Date) {
	return Date.now() < date.getTime();
}

export function isYearEquals(y1: string | Date | number, y2: string | Date | number) {
	const d1 = typeof y1 === 'string' ? dateFromStringValhalla(y1) : new Date(y1);
	const d2 = typeof y2 === 'string' ? dateFromStringValhalla(y2) : new Date(y2);
	return isDateEquals(d1, d2, {
		matchMilliseconds: false,
		matchSeconds: false,
		matchMinutes: false,
		matchHour: false,
		matchDate: false,
		matchMonth: false,
	});
}

export function isCurrentYear(y1: string | Date | number) {
	return isYearEquals(y1, new Date());
}
